package com.essntl.features.itinerary.data.supabase.itinerary

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [ItinerarySupabaseDataSource::class])
internal class ItinerarySupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<ItineraryDto> {
    override val tableName: String = "itinerary"
}
